import { BordOneToneIcon } from 'bord-design-system';
import { bordColorTheme } from 'styles/styles.constants';
import { NudosButton } from 'components/NudosComponents';

import './SessionWaitingPhotos.scss';

interface ISessionWaitingPhotosProps {
  onRescan: () => void;
  onConfirm: () => void;
  isDisabled?: boolean;
}

const SessionWaitingPhotos = ({ onRescan, onConfirm, isDisabled }: ISessionWaitingPhotosProps) => {
  return (
    <div className={`sessionWaitingContainer ${isDisabled ? 'interactionDisabled' : ''}`}>
      <div className="waitingContentLayout">
        <div className="leadWithIcon">
          <BordOneToneIcon
            variant="holdPhone"
            customWidth="4.8rem"
            customClassName="inspectionPhotoEvidenceHoldPhoneIcon"
            stroke={bordColorTheme.navyBlue[500]}
            aria-hidden
          />

          <div className="textBlock">
            <h3 className="waitingTitle">Continúa el proceso desde el teléfono</h3>
            <p className="waitingSubtitle">
              Primero sube las fotos desde tu teléfono. Luego vuelve a esta pantalla y haz clic en{' '}
              <strong>Subir fotos tomadas</strong>.
            </p>
          </div>
        </div>

        <div className="actionButtonsRow">
          <NudosButton
            colorPalette="secondary"
            buttonText="Volver a escanear QR"
            handleClick={onRescan}
            isButtonDisabled={isDisabled}
            customHeight="38px"
          />

          <NudosButton
            buttonText="Subir fotos tomadas"
            colorPalette="primary"
            handleClick={onConfirm}
            isButtonDisabled={isDisabled}
            customHeight="38px"
          />
        </div>
      </div>
    </div>
  );
};

export default SessionWaitingPhotos;
